import { connect } from 'react-redux'
import { AuthRoute } from 'react-router-auth'

const mapStateToProps = (state) => ({
  authenticated: Boolean(state.admin.id),
  redirectTo: '/auth'
})

export default connect(mapStateToProps)(AuthRoute)
